/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
/* istanbul ignore file */

import React, { useState, useEffect } from 'react';
import { setFavorite } from '@catalogo/core-wishlist';
import { withCookies } from '@catalogo/core-connect/cookies';
import { withConfig } from '@catalogo/core-connect/config';
import compose from 'lodash/fp/compose';
import { withRouter } from 'react-router';
import { withMetrics } from '@catalogo/core-metrics';
import WishlistButton from '@catalogo/theme-wishlist';
import { useApolloClient, useLazyQuery } from '@apollo/client';
import { useLazyCustomer } from '@catalogo/service-americanas-common/src/hooks/customer';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';
import {
  getFavorite,
  readFavoriteFromCache,
  writeFavoriteOnCache,
  closureAddFavorite,
} from './helpers/wishlist-helpers';
import IsFavoriteMobileAcom from './is-favorite.graphql';

const Wishlist = ({
  cookies,
  sku,
  product,
  history,
  config,
  hasBoxShadow,
  sizeButton = '50px',
  label,
  dispatchMetrics,
}) => {
  const cache = useApolloClient();
  const customerId = cookies[config?.cookiesKey?.customerId];
  const customerToken = cookies[config?.cookiesKey?.customerToken];
  const hasCustomerCookie = !!customerId && !!customerToken;
  const { isFavoriteOnCache } = readFavoriteFromCache(cache);
  const [sendLoading, setSendLoading] = useState(false);
  const [favoriteState, setFavoriteState] = useState({ called: false });
  const [verifyFavorite, { data, error, loading }] = useLazyQuery(IsFavoriteMobileAcom);

  useEffect(() => {
    if (hasCustomerCookie) {
      verifyFavorite({
        variables: { skuId: `${sku.id}` },
      });
    }
  }, []);

  const saveResult = ({ status, method, ok }) => {
    if (status === 204) {
      dispatchMetrics('event:click', {
        EventCategory: 'favoritos',
        EventLabel: 'pdp',
        EventAction: method === 'DELETE' ? 'remover' : 'adicionar',
      });

      setFavoriteState({
        isFavorite: method === 'DELETE' ? !ok : ok,
        called: true,
      });
    } else {
      setFavoriteState({
        isFavorite: true,
        called: true,
      });
    }
  };

  const handleFavorite = async () => {
    const isFavorite = isFavoriteOnCache ? false : getFavorite(data, hasCustomerCookie, favoriteState);
    writeFavoriteOnCache({ isFavoriteOnCache: false }, cache);
    setSendLoading(true);
    const result = await setFavorite(sku, product, isFavorite, config);
    saveResult(result);
    setSendLoading(false);
  };

  const { fetchCustomer } = useLazyCustomer(
    customerId,
    customerToken,
    handleFavorite,
    replaceUrlParams(history, '#modal-login', false)
  );

  if (hasCustomerCookie && isFavoriteOnCache) {
    handleFavorite();
  }

  const defaultButtonProps = {
    loading: sendLoading || loading,
    sizeIcon: '25px',
    hasBoxShadow,
    sizeButton,
    label,
  };

  return (
    <WishlistButton
      isFavorite={error ? false : getFavorite(data, hasCustomerCookie, favoriteState)}
      addFavorite={closureAddFavorite(fetchCustomer)}
      {...defaultButtonProps}
    />
  );
};

export default compose(withCookies, withRouter, withConfig, withMetrics)(Wishlist);
